export const DEFAULT_PAGE_SIZE = 8;
export const DEFAULT_LAYOUT = "card-grid";
export const LOAD_MORE_URL = "/sports/olympics/summer/myolympics";
export const A11Y_OLYMPICS_CONTENT_TEXT = "Now displaying your Olympics feed";
export const EVENT_SUBJECT =
    "Events/Sports events/Multi-sport events/Olympic games/Summer Olympic games/2024 Paris Olympic Games";
export const NO_ARTICLES_FOUND =
    "No articles found for your selected sport(s). Please choose another sport.";
